/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  AddIcon,
  CloseIcon,
  DeleteIcon,
  EditIcon,
  ExternalLinkIcon,
  TickMarkIcon,
} from '@sketchnote/icons';
import { useRouter } from 'next/router';
import * as React from 'react';
import { useTableStore } from 'src/features/list/store';
import useOnClickOutside from 'use-onclickoutside';

const { memo, useRef, useState } = React;

const MoreActionsCell = ({ data: item, api }: any) => {
  const { onDeleteItem, onDeleteSubItem, onAddNewSubItem } = useTableStore((s) => ({
    onDeleteItem: s.onDeleteItem,
    onDeleteSubItem: s.onDeleteSubItem,
    onAddNewSubItem: s.onAddNewSubItem,
  }));
  const [showDeletePrompt, setDeletePrompt] = useState<boolean>(false);
  const router = useRouter();
  const orgId = router?.query?.orgId;
  const mode = router?.query?.mode;
  const myRef = useRef(null);
  const { isReadOnly } = useTableStore();

  useOnClickOutside(myRef, () => {
    api.stopEditing();
  });

  const handleOpenTask = () => {
    api.stopEditing();
    router.push(
      `/${mode}/${orgId}/files/${router.query.slug}?view=${router.query.view}&type=${router.query.type}&taskId=${item.id}`
    );
  };

  const handleDeleteTask = () => {
    api.stopEditing();
    if (item.isSubtask) {
      onDeleteSubItem({
        columnId: item.isSubtask ? item.parentColumn : item.colId,
        itemId: item.id,
        parentId: item.parent,
      });
    } else {
      onDeleteItem({
        columnId: item.columnId,
        itemId: item.id,
      });
    }
  };

  const handleAddSubtask = () => {
    api.stopEditing();
    onAddNewSubItem({
      columnId: item.columnId,
      parentId: item.id,
    });
  };

  if (isReadOnly) return <span />;

  return (
    <div className="more-menu-popover relative" ref={myRef}>
      {/* <div className="bg-white p-6 flex flex-col gap-0 justify-center  min-w-200 max-h-400 overflow-y-scroll"> */}
      <div className="bg-white w-138 p-6 flex-col inline-flex shadow-sm rounded-md">
        {/* <button
          className="flex font-regular text-gray-700 text-xs py-6 px-4 items-center hover:bg-gray-100 rounded-sm cursor-pointer"
          onClick={handleOpenTask}
        >
          <ExternalLinkIcon wrapperClass="text-gray-500" />
          &nbsp;&nbsp; Open task
        </button> */}
        {!item.isSubtask && (
          <button
            className="flex font-regular text-gray-700 text-xs py-6 px-4 items-center hover:bg-gray-100 rounded-sm cursor-pointer"
            onClick={handleAddSubtask}
          >
            <AddIcon wrapperClass="text-gray-500" />
            &nbsp;&nbsp; Add subtask
          </button>
        )}

        {showDeletePrompt ? (
          <div className="flex font-regular text-gray-700 text-xs py-6 px-4 items-center rounded-sm cursor-pointer">
            <div className="flex w-full justify-between items-center">
              <span>Sure?</span>
              <button
                className=" bg-green-200 hover:bg-green-300 rounded-sm py-1 px-2"
                onClick={handleDeleteTask}
              >
                Yes
              </button>
            </div>
          </div>
        ) : (
          <button
            className="flex font-regular text-gray-700 text-xs py-6 px-4 items-center hover:bg-gray-100 rounded-sm cursor-pointer"
            onClick={() => setDeletePrompt(true)}
          >
            <DeleteIcon wrapperClass="text-gray-500" />
            &nbsp;&nbsp; Delete task
          </button>
        )}
      </div>
    </div>
  );
};

export const MoreActionsCellEditor = memo(MoreActionsCell);
